import type { Levels, TechBranch } from "../shared/game-types";

export const CAPABILITY_LABELS: Readonly<Record<keyof Levels, string>> = {
  civilization: "文明发展",
  industry: "工业能力",
  navigation: "航行能力",
  military: "军事能力",
  energy: "能源能力",
  materials: "材料能力",
};

export const BRANCH_CAPABILITY_LABELS: Readonly<Record<TechBranch, string>> = {
  industry: CAPABILITY_LABELS.industry,
  navigation: CAPABILITY_LABELS.navigation,
  military: CAPABILITY_LABELS.military,
};

const TECHNOLOGY_PREFIX_LABELS: Readonly<Record<string, string>> = {
  I: CAPABILITY_LABELS.industry,
  N: CAPABILITY_LABELS.navigation,
  M: CAPABILITY_LABELS.military,
};

const DEVELOPMENT_STAGE_NAMES = [
  "未探明",
  "初步探测",
  "轨道勘测",
  "自动据点",
  "工业基地",
  "永久殖民地",
  "成熟核心世界",
] as const;

/** Keep stable save IDs internal while presenting a readable level name to players. */
export function technologyLevelLabel(techId: string): string {
  const match = /^([INM])(10|[1-9])$/u.exec(techId);
  if (!match) return "未知科技等级";
  return `${TECHNOLOGY_PREFIX_LABELS[match[1]!] ?? "科技"} ${match[2]}级`;
}

export function developmentStageLabel(level: number): string {
  const normalized = Number.isFinite(level) ? Math.max(0, Math.min(6, Math.round(level))) : 0;
  return `${normalized}级 · ${DEVELOPMENT_STAGE_NAMES[normalized]}`;
}
